import gql from 'graphql-tag';

export const SpacePropertiesQuery =
	// eslint-disable-next-line graphql-relay-compat/no-experimental-directives -- Read http://go/cfe-no-experimental-directives
	gql`
		query SpacePropertiesQuery($spaceKey: String!, $propertyKeys: [String!]!) @experimental {
			experimentalSpaceProperties(spaceKey: $spaceKey, propertyKeys: $propertyKeys) {
				key
				value
			}
		}
	`;
